var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 143.879,
    height: 150,
    viewBox: "0 0 143.879 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M213.322,95.6c2.785.832,5.7,1.365,8.33,2.55a25.647,25.647,0,0,1,14.638,24.073,26.1,26.1,0,0,1-8.013,18.119q-32.534,32.495-65.066,64.991a7.276,7.276,0,0,1-3.363,1.846c-12.411,2.787-24.846,5.47-37.275,8.178-4.261.928-6.769-1.6-5.838-5.863,2.7-12.38,5.381-24.766,8.141-37.133a6.2,6.2,0,0,1,1.547-2.88q32.876-33.085,65.825-66.1a25.054,25.054,0,0,1,14.991-7.552,1.96,1.96,0,0,0,.518-.231ZM192.575,115l-57.109,57.108,24.459,25.09,57.115-57.768Zm5.613-6.038,25.233,24.569c6.5-5.726,6.488-17.647-.281-24.536S204.629,101.98,198.188,108.96Zm-66.77,72.048c-1.814,8.245-3.656,16.623-5.558,25.268l25.257-5.566Z",
    transform: "translate(-109.445 -95.604)",
    fill: "#674188"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M105,396.279c-2.347-1.213-3.276-2.56-3.067-4.448a3.97,3.97,0,0,1,3.486-3.595,12.351,12.351,0,0,1,1.9-.091q66.533-.005,133.066,0c.391,0,.782-.013,1.171.007a4.088,4.088,0,0,1,4.161,3.393c.348,1.97-.581,3.533-2.662,4.494a2.534,2.534,0,0,0-.354.243Z",
    transform: "translate(-101.907 -246.279)",
    fill: "#674188"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFill);
export default __webpack_public_path__ + "static/media/EditFill.4d15ff6bf7c88f5bda1618c9fbbcd53d.svg";
export { ForwardRef as ReactComponent };